<template>
	<div>
		<div>
			<el-row  :gutter="12">
				<el-col :span="6">
					<el-button @click="openDialog" type="primary">新建投放点</el-button>
					<el-select v-model="optionMethod" @change="optionChange" style="width: 80px;margin-left: 3px;" placeholder="更多">
						<el-option label="删除" value="1"></el-option>
						<el-option label="修改" value="2"></el-option>
					</el-select>
				</el-col>
				<el-col :span="18">
					<div style="width: 100%;text-align: right;">
						<el-input type="text" style="width:300px;margin-left: 3px;" v-model="queryValue" placeholder="请输入">
							<el-button slot="append" icon="el-icon-search" @click="queryData">搜索</el-button>
						</el-input>
					</div>
				</el-col>
			</el-row>
		</div>
		<div style="margin-top: 15px;">
			<el-table ref="multipleTable" 
			    :data="tableData" 
				style="width: 100%" 
				element-loading-text="数据正在加载中" 
				@selection-change="handleSelectionChange"
				:header-cell-style="headClass"
			 	:row-style="rowClass">
			    <el-table-column type="selection" width="60"></el-table-column>
			    <el-table-column prop="agentId" label="代理商id" sortable></el-table-column>
			    <el-table-column prop="location" label="详细地址"></el-table-column>
			    <el-table-column prop="nickname" label="地址简称"></el-table-column>
			    <el-table-column label="操作">
			      	<template slot-scope="scope">
			      		<button @click="openUpdate(scope.row)">修改</button>
			      	</template>
			    </el-table-column>
		    </el-table>
		    <el-pagination background
	    			style="text-align:right;margin-top: 15px;"
		            @size-change="handleSizeChange"
		            @current-change="handleCurrentChange"
		            :current-page="currentPage"
		            :page-sizes="[10, 50, 100, 200]"
		            :page-size="pageSize" 
		            layout="total, sizes, prev, pager, next, jumper"
		            :total="total">
		    </el-pagination>
		</div>
		<el-dialog :title="title" :visible.sync="myDialog">
			<div>
				<table>
					<tr>
						<td>详细地址</td>
						<td>
							<el-input v-model="address"></el-input>
						</td>
					</tr>
					<tr>
						<td>地址简称</td>
						<td>
							<el-input v-model="nickname"></el-input>
						</td>
					</tr>
				</table>
			</div>
			<div style="width: 60%;text-align: right;margin-top: 20px;">
				<el-button v-if="isNew" @click="newPlace">创建投放点</el-button>
				<el-button v-if="!isNew" @click="updatePlace">修改投放点</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'launchPoint',
  components: {
  },
  data() {
    return {
    	total: 0,
        currentPage: 1,
　　  	pageSize: 10,
		tableData:[],
		optionMethod:"",
		address:'',
		nickname:'',
		myDialog:false,
		title:'新增投放点',
		isNew:true,
		placementId:''
    }
  },
  watch: {
  },
  mounted() {
  	this.updateTable();
  },
  beforeDestroy() {
  },
  methods: {
  	handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  	handleSizeChange(val) {
      this.pageSize = val;
      this.updateTable();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.updateTable();
    },
    updateTable(){
    	var thiz = this;
    	axios.get(this.$store.getters.getApiValue+'/srsPlacement/getMyPlacementList.do',{
  			params:{
  				pageId:thiz.currentPage,
  				size:thiz.pageSize
  			}
  		}).then(function (response) {
		    var data = response.data;
		    if(data.status == "200"){
		    	thiz.total = data.totalCount;
		    	thiz.tableData = data.data;
		    }
		  }).catch(function (error) {
		    console.log(error);
		  });
    },
    queryData(){
    	var thiz = this;
    	var param = {
    		pageId:this.currentPage,
  			size:this.pageSize
    	}
    	if(this.queryValue != ""){
    		param.keyword = this.queryValue;
    	}
    	axios.get(this.$store.getters.getApiValue+'/srsPlacement/searchMyPlacementList.do',{
  			params:param
  		}).then(function (response) {
		    var data = response.data;
		    if(data.status == "200"){
		    	thiz.total = data.totalCount;
		    	thiz.tableData = data.data;
		    }
		  }).catch(function (error) {
		    console.log(error);
		  });
    },
    openDialog(){
		this.address = "";
		this.nickname = "";
		this.title = "新增投放点"
		this.isNew = true;
    	this.myDialog = true;
    },
    newPlace(){
    	var thiz = this;
    	axios.get(this.$store.getters.getApiValue+'/srsPlacement/addPlacement.do',{
    		params:{
    			location:this.address,
    			nickname:this.nickname
    		}
    	}).then(function (response) {
			    var data = response.data;
			    if(data.status == "200"){
			    	thiz.updateTable();
			    	thiz.myDialog = false;
			    }
			  }).catch(function (error) {
			    console.log(error);
			  });
    },
    headClass({ row, rowIndex}) {
    	if(rowIndex == 0){
    		return ''
    	}
	    return ''
	},
    rowClass({ row, rowIndex}) {
	    if(rowIndex%2 == 0){
	    	return 'background:#F1F2F7;'
	    }else{
	    	return 'background:white;'
	    }
	    return ''
	},
	optionChange(){
		console.log(this.optionMethod);
	},
	openUpdate(row){
		this.placementId = row.placementId;
		this.address = row.location;
		this.nickname = row.nickname;
		this.title = "修改投放点"
		this.isNew = false;
    	this.myDialog = true;
	},
	updatePlace(){
		var thiz = this;
    	axios.get(this.$store.getters.getApiValue+'/srsPlacement/updatePlacement.do',{
    		params:{
    			placementId:this.placementId,
    			location:this.address,
    			nickname:this.nickname
    		}
    	}).then(function (response) {
			    var data = response.data;
			    if(data.status == "200"){
			    	thiz.updateTable();
			    	thiz.myDialog = false;
			    }
			  }).catch(function (error) {
			    console.log(error);
			  });
	}
  }
}
</script>

<style>
</style>